import React from "react";
import styled from "styled-components";
import { FaAndroid, FaApple, FaGlobe } from "react-icons/fa";
import { gradients } from "./theme/theme";

const projects = [
  {
    title: "Cinystore",
    desc: "A complete classified app with chat, ad filters, call/WhatsApp integration.",
    platforms: ["android", "ios"],
  },
  {
    title: "HiresGulf",
    desc: "Attendance & performance tracker with charts and local SQLite support.",
    platforms: ["android", "ios"],
  },
  {
    title: "DealDome",
    desc: "AI-powered resume & portfolio QR card with job suggestions and real-time updates.",
    platforms: ["web", "android", "ios"],
  },
  {
    title: "Punjabi Jukebox",
    desc: "Platform for posting & solving real-world code issues with money & leaderboard.",
    platforms: ["android", "ios"],
  },
  {
    title: "EV Bike Rent App",
    desc: "Platform for posting & solving real-world code issues with money & leaderboard.",
    platforms: ["android", "ios"],
  },
  {
    title: "Doc Scanner App",
    desc: "Platform for posting & solving real-world code issues with money & leaderboard.",
    platforms: ["android", "ios"],
  },
];

const ProjectsDelivered = () => {
  return (
    <Container>
      <Heading>🚀 Projects Delivered</Heading>
      <List>
        {projects.map((project, index) => (
          <Card key={index}>
            <LeftBar>
              {project.platforms.includes("android") && (
                <FaAndroid color="#3DDC84" />
              )}
              {project.platforms.includes("ios") && <FaApple color="#fff" />}
              {project.platforms.includes("web") && <FaGlobe color="#0070f3" />}
            </LeftBar>
            <Content>
              <Title>{project.title}</Title>
              <Description>{project.desc}</Description>
            </Content>
          </Card>
        ))}
      </List>
    </Container>
  );
};

export default ProjectsDelivered;

// Styled Components

const Container = styled.div`
  padding: 60px 20px;
  background: ${gradients.heroBackground};
`;

const Heading = styled.h2`
  text-align: center;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 700;
  margin-bottom: 40px;
  color: #fff;
`;

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
`;

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 480px;
  padding: 20px 24px;
  border-radius: 16px;

  backdrop-filter: blur(6px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px dashed rgba(255, 255, 255, 0.2);

  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 255, 255, 0.4);
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const LeftBar = styled.div`
  min-width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-right: 16px;
  border-right: 2px dashed rgba(255, 255, 255, 0.2);
  margin-right: 20px;

  svg {
    font-size: 26px;
    transition: transform 0.2s ease;
  }

  ${Card}:hover & svg {
    transform: scale(1.2);
  }

  @media (max-width: 600px) {
    flex-direction: row;
    border-right: none;
    border-bottom: 2px dashed rgba(255, 255, 255, 0.2);
    padding-bottom: 12px;
    margin-bottom: 16px;
    padding-right: 0;
    margin-right: 0;
  }
`;

const Content = styled.div`
  flex: 1;
`;

const Title = styled.h3`
  font-size: 20px;
  color: white;
  font-weight: 600;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 15px;
  line-height: 1.4;
  color: rgba(228, 228, 228, 0.7);
`;
